import { render, staticRenderFns } from "./newFAQ.vue?vue&type=template&id=7b2aa1aa&scoped=true&"
import script from "./newFAQ.vue?vue&type=script&lang=js&"
export * from "./newFAQ.vue?vue&type=script&lang=js&"
import style0 from "./newFAQ.vue?vue&type=style&index=0&id=7b2aa1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2aa1aa",
  null
  
)

export default component.exports